import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { List, ListItemText, ListItem, Collapse, } from '@material-ui/core';
import { ExpandLess, ExpandMore, } from '@material-ui/icons';
import OpenNewWindowButton from './OpenNewWindowButton';

class LinkItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // locatPath: window.location.pathname.split('/').filter((x) => x != ""),
            // sidebarItemActive: window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].replace(".html", ""), //現在位置的人要亮
            breakException: sessionStorage.getItem("items") === "undefined" ? "" : JSON.parse(sessionStorage.getItem("items")),
            sidebarisOpen: false,
            newWindowPageId: null,
        };
        this.newWindowTimer = null;
    }

    componentDidMount = async () => {
        const locatPath = window.location.pathname.split('/').filter((x) => x !== "");
        if (locatPath[0] === this.props.sidebarRes.code) {
            this.setState({
                sidebarisOpen: true,
            })
        } else {
            this.setState({
                sidebarisOpen: false,
            })
        }
    }

    sidebarDrawer = () => {
        this.setState({
            sidebarisOpen: !this.state.sidebarisOpen,
        })
    }

    componentWillUnmount = () => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
    }

    enableNewWindow = (pageId) => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
        this.newWindowTimer = setTimeout(() => {
            this.setState({ newWindowPageId: pageId });
            this.newWindowTimer = null;
        }, 1200);
    }

    disableNewWindow = () => {
        if (this.newWindowTimer) clearTimeout(this.newWindowTimer);
        this.newWindowTimer = null;
        this.setState({ newWindowPageId: null });
    }

    render() {
        let sidebarAcitve = this.props.sidebarActive;
        if (this.props.sidebarRes.children.filter(item => item.code === this.props.sidebarActive).length === 0) {
            const sideArr = this.props.sidebarRes.children.filter(item => item.path.indexOf('/' + window.location.pathname.split('/')[window.location.pathname.split('/').length - 2].replace(".html", "")) !== -1);
            if (sideArr.length !== 0) {
                sideArr.map((item, index) => {
                    if (item.children.length !== 0) {
                        item.children.map((item2, index2) => {
                            if (item2.code === this.props.sidebarActive) {
                                sidebarAcitve = item.code;
                            }
                        });
                    }
                });
            }
        }

        return (
            <div>
                <ListItem
                    button
                    to={"/" + this.props.sidebarRes.code}
                    data-pg_id={this.props.sidebarRes.pg_id}
                    onClick={this.sidebarDrawer}>
                    <ListItemText primary={this.props.sidebarRes.name} />
                    {this.state.sidebarisOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse component="li" in={this.state.sidebarisOpen} timeout="auto" unmountOnExit style={{ background: "#efeff1" }}>
                    <List disablePadding>
                        {[...this.props.sidebarRes.children].sort((a, b) => a.page_id - b.page_id).map((sub, index) => {
                            let act = (match, location) => { //跳轉到下一層路徑就不匹配了，所以要判斷
                                let pathStrings = location.pathname.split('/');
                                if (match) {
                                    return true;
                                } else if (pathStrings[1] === this.props.sidebarRes.code) {
                                    if (location.pathname.endsWith("/" + sub.code)) { //選單有子層，需判斷組別跟哪一層
                                        return true;
                                    } else if ("/" + this.props.sidebarRes.code + "/" + sub.code === "/" + this.props.sidebarRes.code + "/" + pathStrings[1]) {
                                        return true;
                                    }
                                } else {
                                    return false;
                                }
                            }
                            return (
                                <NavLink
                                    key={sub.page_id}
                                    isActive={act}
                                    data-pg_id={this.props.sidebarRes.pg_id}
                                    data-page_id={sub.page_id}
                                    to={"/" + this.props.sidebarRes.code + "/" + sub.code}>
                                    <ListItem
                                        button
                                        to={"/" + this.props.sidebarRes.code + "/" + sub.code}
                                        className={sidebarAcitve === sub.code ? "active" : ""}
                                        onMouseEnter={() => this.enableNewWindow(sub.page_id)}
                                        onMouseLeave={this.disableNewWindow}
                                        onClick={(e) => this.props.handleListItemClick({ "target": { "name": sub.code, "value": e, } })}>
                                        <ListItemText primary={sub.name} />
                                        <OpenNewWindowButton
                                            url={"/" + this.props.sidebarRes.code + "/" + sub.code}
                                            className="nw"
                                            isNewWindowEnabled={this.state.newWindowPageId === sub.page_id}
                                        />
                                    </ListItem>
                                </NavLink>
                            )
                        })}
                    </List>
                </Collapse>
            </div >
        );
    }
}

export default LinkItem;